import React, { useCallback, useEffect, useState, memo } from "react";
import profile_Img from "../../Assets/Images/user.png";
import { useDispatch, useSelector } from "react-redux";
import {
  decryptMessage,
  decryptText,
} from "../EncryptDecryptMessage/EncryptDecryptMessage";
import { converId } from "../../Redux/slices/ChatSlice";

const UserChatList = memo(({
  key,
  chat,
  setActiveChat,
  activeChat,
  setCreateChatId,
  setShowAddMenu,
  setChatConversationId,
  setGetSecretKey,
  setActiveSection,
  setIsMessageLoading,
  setShowProfileView,
}) => {
  const { socket } = useSelector((state) => state.socket);
  const { userInfo } = useSelector((state) => state.authUser);
  const { conversationId: currentConversationId } = useSelector((state) => state.chatUser);
  const dispatch = useDispatch();

  const joinConversation = (conversationId) => {
    socket.emit("joinConversation", { id: conversationId });
  };
  const handleChatChangeConversation = async (conversationId) => {
    socket.emit("disconnectConversation", { id: conversationId });
  };

  const handleClick = (chat) => {
    if (activeChat?.user?._id === chat?.user?._id) {
      return;
    }
    setShowProfileView(false);
    setShowAddMenu(false);
    // OPTIMIZATION: Don't block on secret key - it will be set by Layout's useEffect
    // The secret key is now cached and loaded instantly from cache
    setActiveChat(chat);
    dispatch(converId(chat?.conversationId?._id));

    // Disconnect from previous conversation (if any)
    if (currentConversationId) {
      handleChatChangeConversation(currentConversationId);
    }

    // Set new conversation ID (this triggers the useEffect in Layout.js)
    // Ensure we pass the conversationId object, not just the _id
    setChatConversationId(chat?.conversationId);

    // Join new conversation
    if (!chat?.user?.isBlocked && chat?.conversationId?._id) {
      joinConversation(chat.conversationId._id);
    }
    setActiveSection("contact");
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    const today = new Date();

    if (date.toDateString() === today.toDateString()) {
      // show time
      return date.toLocaleString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } else {
      // return date in MM-DD-YYYY format
      return date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
    }
  };

  return (
    <>
      <li
        onClick={() => handleClick(chat)}
        className={`flex justify-between items-center p-3 px-4 mt-2 rounded-xl transition-all cursor-pointer 
    ${activeChat?.user?._id === chat?.user?._id
            ? "bg-indigo-600 text-white shadow-sm"
            : "bg-transparent hover:bg-white dark:hover:bg-slate-700 hover:shadow-sm"
          }`}
        key={key}
      >
        <div className="flex w-full">
          <img
            src={chat?.user?.mediaUrl || chat?.user?.avtarImage || profile_Img}
            alt={chat?.user?.name}
            className={`${chat?.user?.avtarImage || chat?.user?.mediaUrl
              ? "max-w-[46px] max-h-[46px] rounded-full min-w-[46px] min-h-[46px] object-cover"
              : "object-cover max-w-[46px] max-h-[46px] p-1 rounded-full"
              }`}
          />

          <div className="flex justify-between items-start w-full ml-2">
            {/* Left Side: Name + Message */}
            <div className="flex flex-col w-[calc(100%-5px)]">
              <span className={`font-semibold text-sm truncate max-w-60 ${activeChat?.user?._id === chat?.user?._id ? "text-white" : "text-zinc-900 dark:text-zinc-100"
                }`}>
                {chat?.user?.name}
              </span>
              <span
                className={`text-xs font-normal max-w-62 truncate break-words mt-1.5 ${activeChat?.user?._id === chat?.user?._id ? "text-zinc-300" : "text-zinc-500 dark:text-zinc-400"
                  }`}
              // style={{
              //   display: "-webkit-box",
              //   WebkitLineClamp: 1,
              //   WebkitBoxOrient: "vertical",
              // }}
              >
                {chat?.latestMessage?.messageType === "LOCATION"
                  ? "Location"
                  : chat?.latestMessage?.cipherText
                    ? chat?.latestMessage?.cipherText
                    : chat?.latestMessage?.fileType ||
                    chat?.latestMessage?.mediaId?.fileType}
              </span>
            </div>

            {/* Right Side: Time + Badge */}
            <div className="flex flex-col items-end ml-2 min-w-[60px] pt-0.5">
              <span className={`text-[12px] ${activeChat?.user?._id === chat?.user?._id ? "text-zinc-300" : "text-zinc-500 dark:text-zinc-400"
                }`}>
                {chat?.latestMessage?.sentTime &&
                  formatDate(chat?.latestMessage?.sentTime)}
              </span>
              {chat?.unseenMessageCount > 0 && (
                <span
                  className={`
      bg-[#06B300] text-white text-[10px] font-semibold mt-2
      flex items-center justify-center h-4 px-1 rounded-md
      ${chat.unseenMessageCount > 9 ? "min-w-[1.2rem]" : "w-4"}
    `}
                >
                  {chat.unseenMessageCount > 99
                    ? "99+"
                    : chat.unseenMessageCount}
                </span>
              )}
            </div>
          </div>
        </div>
      </li>
    </>
  );
});

// Memoize to prevent unnecessary re-renders when other chats update
UserChatList.displayName = "UserChatList";

export default UserChatList;
